<div class="top-banner">
  <div class="banner-left">
    <span *ngIf="isAdminLoggedIn && adminUserInfo.tenantId">
      Tenant: {{  tenantName  || '—' }}
    </span>
  </div>
  <!-- <div class="banner-left">
    <span *ngIf="tenantName">Org: {{ tenantName }}</span>
  </div> -->
  <div class="banner-right">
    <span *ngIf="isAdminLoggedIn && adminUserInfo.userName; else guestBanner">
      Logged in as {{ adminUserInfo.userName }}
    </span>
    <ng-template #guestBanner>
      <span>Please log in</span>
    </ng-template>
  </div>
</div>
